// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2qSPP","emails":"CreateEditClinics_emails__2j_Vr","emailTagLabel":"CreateEditClinics_emailTagLabel__3mpRf"};